import axios from "axios";
import 'vue-loading-overlay/dist/vue-loading.css';

export const ImageScanImportService = {
    /**
      * Downloads a document template based on the specified scan file type.
      *
      * @param {string} scanFileType - The type of scan file to download. Must be either 'parent' or 'student'.
      * @returns {Promise<{ success: boolean, message: string }>} - A promise that resolves to an object indicating the success of the download and a message.
      * @throws {Error} - Throws an error if an invalid scan file type is specified.
      */
    async downloadDocumentTemplate(scanFileType) {
        let apiEndPoint='';
        try {
            switch (scanFileType) {
                case 'parent':
                    apiEndPoint = "parent/download/wordFileTemplate";
                    break;
                case 'student':
                    apiEndPoint = "student/download/wordFileTemplate";
                    break;
                default:
                    throw new Error('Invalid type specified. Must be "parent" or "student".');
            }
            const response = await axios.get(apiEndPoint, {
                responseType: 'blob',
            });
            const disposition = response.headers['content-disposition'];
            let fileName = 'word_import_template.docx';
            if (disposition && disposition.includes('filename=')) {
                fileName = disposition
                    .split('filename=')[1]
                    .split(';')[0]
                    .trim()
                    .replace(/['"]/g, '');
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName; 
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);

            return { success: true, message: 'File downloaded successfully!' };
    
        } catch (error) {
            return { success: false, message: 'File download failed. Please try again.' };
        }
    },

    /**
      * Send uploaded image file to the appropriate API endpoint based on the scan file type.
      *
      * @param {File} file - The image file to be scanned.
      * @param {string} scanFileType - The type of scan to perform ('parent' or 'student').
      * @returns {Promise<Object>} - A promise that resolves to an object containing the success status and message.
      * @throws {Error} - Throws an error if an invalid scan file type is specified.
      */
    async scanImageFileData(file, scanFileType) {
        let apiEndPoint='';
        try {
            let data = new FormData();
            data.append('image', file);
            switch(scanFileType) {
                case 'parent':
                    apiEndPoint = "parent/scan-image";
                    break;
                case 'student':
                    apiEndPoint = "student/scan-image";
                    break;
                default:
                    console.error('invalid type');
                    throw new Error('Invalid type specified. Must be "parent" or "student".');
            }
            const response = await axios.post(apiEndPoint, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.success) {
                return { success: true, message: response.data.message, data: response.data.data };
            } else {
                return { success: false, message: response.data.message };
            }
        } catch (error) {
            this.isLoading = false;
            return { success: false, message: 'File to scan import image file. Please try again.' };
        }
    },
};
